const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteCard = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADMIN_DELETE_CARD_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'ADMIN_DELETE_CARD_ERROR':
            return { loading: false, error: true, data: [] };
        case 'ADMIN_DELETE_CARD_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'ADMIN_DELETE_CARD_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteCard